/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-08-29 16:18:03
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-08-29 16:19:23
 * @FilePath: \mpc-3\features\common\src\utils\withFunctionCall.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { ComponentProps, JSXElementConstructor } from 'react';
import * as ReactDOM from 'react-dom';
import { ConfigProvider, Theme } from '@bedrock/components';
import { ScreenAdapterContext } from '@bedrock/eed-react';

const withFunctionCall = <
  T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>
>(
  OriginalModal: T
): {
  show: (
    config: Omit<ComponentProps<T>, 'visible' | 'onCancel'>,
    screenAdapter?: any
  ) => {
    close: () => void;
  };
} => {
  const show = (config, screenAdapter = { viewBase: 1 }) => {
    const div = document.createElement('div');
    document.body.appendChild(div);

    function destroy() {
      const unmountResult = ReactDOM.unmountComponentAtNode(div);
      if (unmountResult && div.parentNode) {
        div.parentNode.removeChild(div);
      }
      window.removeEventListener('popstate', handlePopState);
    }

    // 监听浏览器的前进后退事件，当用户点击浏览器的前进或后退按钮时，销毁弹框。
    function handlePopState() {
      console.log('popstate event triggered');
      destroy();
      window.removeEventListener('popstate', handlePopState);
    }
    window.addEventListener('popstate', handlePopState);

    // 创建一个 Provider 组件，接收 screenAdapter 作为 props
    const Provider: React.FC<{ children: React.ReactNode; screenAdapter: any }> = ({ children, screenAdapter }) => (
      <ScreenAdapterContext.Provider value={screenAdapter}>
        <ConfigProvider
          ratio={screenAdapter?.viewBase} // 设置组件内部的ratio，影响组件内部样式；
        >
          <Theme>{children}</Theme>
        </ConfigProvider>
      </ScreenAdapterContext.Provider>
    );

    function render(props) {
      ReactDOM.render(
        <Provider screenAdapter={screenAdapter}>
          <OriginalModal
            visible
            onOk={() => destroy()}
            onCancel={() => destroy()}
            onClose={() => destroy()}
            {...props}
          />
        </Provider>,
        div
      );
    }

    render(config);

    return {
      close: destroy,
    };
  };

  return {
    show,
  };
};

export default withFunctionCall;
